// Thanh lưu dính đáy màn hình — chỉ hiện khi có thay đổi chưa lưu.
import { Button } from "antd";

export default function XuConfigSaveBar({ count, saving, onCancel, onSave }) {
    if (!count) return null;
    return (
        <div className="sticky bottom-0 z-10 -mx-4 lg:-mx-5 mt-4">
            <div className="flex flex-wrap items-center justify-between gap-2 px-4 lg:px-5 py-3 border-t shadow-[0_-4px_12px_rgba(0,0,0,0.08)]"
                style={{ background: "var(--ant-color-bg-container, #fff)", borderColor: "var(--ant-color-border-secondary, #e5e7eb)" }}>
                <span className="text-sm"><span className="inline-block w-2 h-2 rounded-full bg-amber-500 mr-2" />Bạn có <b>{count}</b> thay đổi chưa lưu</span>
                <div className="flex gap-2">
                    <Button onClick={onCancel} disabled={saving}>Huỷ</Button>
                    <Button type="primary" loading={saving} onClick={onSave}>Xem &amp; lưu</Button>
                </div>
            </div>
        </div>
    );
}
